import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ANALYTICS_REPORT } from 'constants/Entities';
import { METABASE_REPORT } from 'constants/DashboardProviders';
import AnalyticsEmptyView from './DashboardEmptyView';
import SharedList from '../SharedList';

const DashboardList = ({
    pathItemSelected,
    loading,
    error,
    onDrop,
    dragInfo,
    refreshList,
    refreshFavorites,
    onChange,
    onCreateFolder,
    onEditFolder,
}) => {
    const analyticsProCreateFolder = useSelector(
        (state) => state.config?.permission?.analyticsProCreateFolder,
    );

    const emptyViewProps = useMemo(() => {
        return {
            others: {
                onCreateFolder,
                analyticsProCreateFolder,
            },
        };
    }, [analyticsProCreateFolder, onCreateFolder]);

    const innerData = useMemo(() => {
        let rows = pathItemSelected?.children?.length && !error ? pathItemSelected?.children : [];
        // Metabase dashboards with visibleIn should not be displayed in the dashboard list
        const dashboards = (pathItemSelected.dashboards || []).filter((current) => {
            if (
                parseInt(current.idProvider, 10) === parseInt(METABASE_REPORT, 10) &&
                current.visibleIn
            ) {
                return false;
            }
            return true;
        });
        if (dashboards.length) rows = [...rows, ...dashboards];

        return {
            data: loading || !rows ? null : rows,
            error,
            loading,
        };
    }, [error, loading, pathItemSelected?.children, pathItemSelected?.dashboards]);

    return (
        <SharedList
            entity={ANALYTICS_REPORT}
            innerData={innerData}
            emptyViewProps={emptyViewProps}
            customEmptyViewComponent={AnalyticsEmptyView}
            onDrop={onDrop}
            dragInfo={dragInfo}
            refreshList={refreshList}
            refreshFavorites={refreshFavorites}
            onChange={onChange}
            onEditFolder={onEditFolder}
            columnsToInclude={['name']}
        />
    );
};

export default memo(DashboardList);
